
<div class="modal right" id="customerDetail" tabindex="-1" role="dialog" aria-labelledby="customerDetailLabel">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content" id="print-content">
			<div class="modal-header hide-print">
				<div class="modal-title">
					<h4 id="customerDetailLabel">Partner Detail</h4>
				</div>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<i class="icon-close-circle"></i>
				</button>
            </div>
            <div class="modal-body order-detail-page">
				<ul class="nav nav-tabs nav-justified" id="tabContent">
					<li class="active">
						<a target="_self" href="#customerDetail" data-toggle="tab">Details</a>
					</li>
                    <li>
                        <a target="_self" href="#notes" data-toggle="tab">Notes
                            <span class="badge label-danger" ng-if="customer.note_count > 0">{{ customer.note_count }}</span>
                        </a>
                    </li>
                    <!-- <li>
                        <a target="_self" href="#fields" data-toggle="tab">Özel Alanlar</a>
                    </li> -->
                    <li>
                        <a target="_self" href="#access_token" data-toggle="tab">API Key</a>
                    </li>
                    <li>
                        <a target="_self" href="#integrations" data-toggle="tab">Integrations</a>
                    </li>
					<!-- <li><a target="_self" href="#activity" data-toggle="tab">Çalışan Etkinlikleri</a></li> -->
				</ul>

				<div class="tab-content">
					<div class="tab-pane active" id="customerDetail">
						<div class="modal-body-container">
							<div class="row">
								<div class="col-md-9 mt-2">
									<div class="col-md-6 mt-2">
									<div class="panel mb-10">
										<p>
											<strong>Partner Name </strong>
											<span>
                                                <img 
                                                    ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ customer.logo }}" 
                                                    class="img-responsive text-center img-circle" 
                                                    width="36px" 
                                                    height="36px" 
                                                    ng-if="customer.logo"
                                                    style="width:36px; height:36px;" 
                                                    class="img-responsive">

												{{ customer.customer_name }}
											</span>
										</p>
										<p>
											<strong>Doing Business As (DBA) </strong>
											<span>
												{{ customer.dba_name }}
											</span>
										</p>
										<p>
											<strong>Email</strong>
											<span>
												{{ customer.user.email }}
											</span>
										</p>
										<p>
											<strong>Authorized </strong>
											<span>
												{{ customer.authorized }}
											</span>
										</p>
										<p>
											<strong>Phone Number </strong>
											<span>
												{{ customer.phone_number }}
											</span>
										</p>
										<p>
											<strong>Customer Service Phone Number</strong>
											<span>
												{{ customer.cs_phone_number ? customer.cs_phone_number : '-' }}
											</span>
										</p>
									</div>
									</div>
									<div class="col-md-6 mt-2">
										<div class="panel mb-10">
											<p>
												<strong>Address : </strong>
												<span>{{ customer.address }} {{ customer.address2 }}  </span>
											</p>
											<p>
												<strong>City</strong>
												<span>
													{{ customer.city }}
												</span>
											</p>
											<p>
												<strong>State </strong>
												<span>
													{{ customer.state }}
												</span>
											</p>
											<p>
												<strong>Zipcode </strong>
												<span>
													{{ customer.zipcode }}
												</span>
											</p>
											<p>
												<strong>Created At </strong>
												<span>{{ customer.created_at | amUtc | amDateFormat:'MM/DD/YYYY, HH:mm' }}</span>
											</p>
											<p>
												<strong>Price Per Order </strong>
												<span>$ {{ customer.online_payment_factor }}</span>
											</p>
											<p>
												<strong>Comission Rate </strong>
												<span>% {{ customer.comission_rate }}</span>
											</p>
											<p ng-repeat="item in workTypes">
												<strong>{{ item.name}} Price : </strong>
												<span>{{ customer.pricing[item.id] }}</span>
											</p>
											<!-- <p>
												<strong>Karşıdan Ödemeli Fiyat : </strong> 
												<span>{{ customer.payable_payment_factor }} </span>
											</p>
											-->
											<p ng-repeat="item in customer.fields">
												<strong>{{ item.name }} : </strong>
												<span>{{ item.field_value.value }} </span>
											</p>
										</div>
									</div>
								</div>
								<div class="col-md-3 mt-4">
									<a 
										href="#" 
										ng-if="can('maps')"
										ng-click="editData()"
										class="hod-button blue">
										Edit
									</a>

									<a 
										href="#" 
										class="hod-button mb-2 mt-2 btn-block blue" 
										ng-click="changeCustomerStatus(0)" 
										ng-if="customer.user.status == 1">
										Approve
									</a>
                                </div>
                                
							</div>
						</div>
                    </div>
					<div class="tab-pane" id="notes">
						<div class="modal-body-container">
                            <div class="chat-window">
                                <div class="panel panel-default pt-0">
                                    <div class="msg_container_base">
                                        <div class="row msg_container base_receive" ng-repeat="note in customer.notes">
                                            <div class="col-md-12 col-xs-12">
                                                <div class="messages msg_receive">
                                                    <p>{{ note.note }}</p>
                                                    <a href="">{{ note.full_name }} -- <time datetime="2009-11-13T20:00">{{ note.created_at | amUtc | amDateFormat:'MM/DD/YYYY, hh:mm A' }}</time></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row msg_container base_receive" ng-if="customer.notes.length == 0">
                                            <div class="col-md-12 col-xs-12">
                                                <div class="messages msg_receive">
                                                    <p>No notes have been entered yet.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer-container">
                            <div class="input-group">
								<input ng-model="description" type="text" id="noteInputCustomer" class="form-control input-sm chat_input" placeholder="Write a note..." ng-disabled="noteAdding" />
                                <span class="input-group-btn">
                                    <a href="" ng-click="sendCustomerNote(description,customer.id)" class="btn btn-primary btn-sm" id="btn-chat">Send</a>
                                </span>
                            </div>
						</div>
                    </div>
					<div class="tab-pane" id="access_token">
						<div class="modal-body-container">
							<div class="row">
								<div class="col-md-12 mt-2">
                                    <div class="panel mb10">
                                        <h4>
                                            API Key
                                            <a href="#" ng-click="createWebhook()" ng-if="customer.user.webhook.length == 0" class="btn btn-primary btn-sm pull-right">
                                                <i class="fa fa-plus"></i>
                                                New Key
                                            </a>
                                        </h4>
                                        <code class="p20 mb10" ng-if="customer.user.webhook.length != 0" style="display:block">
                                            {{ customer.user.webhook }}
                                        </code>
                                    </div>
								</div>
							</div>
						</div>
                    </div>
					<div class="tab-pane" id="integrations">
						<div class="modal-body-container">
							<div class="row">
								<div class="col-md-12 mt-2">
                                    <div class="panel mb10">
                                        <h4>
                                            Integrations
                                        </h4>

										<a href="#" class="hod-button blue" ng-click="addAlias()">Add Integration</a>

										<div class="row mt-2" ng-repeat="item in customer.aliases">
											<div class="col-4 pr-1">
												<div class="form-group floating">
													<input type="text" ng-model="item.alias" placeholder="Email" class="form-control input-md ">
													<label>Email</label>
												</div>
											</div>
											
											<div class="col pl-1">
												<div class="form-group floating">
													<select ng-model="item.integration" class="form-control" required>
														<option value="">Select Integration</option>
														<option value="grubhub">Grubhub</option>
														<option value="doordash">Doordash</option>
														<option value="delivery">Delivery.com</option>
														<option value="slice">Slice</option>
													</select>
													<label>Integration</label>
												</div>
											</div>
											<div class="col pl-1">
												<div class="form-group floating">
													<select ng-model="item.auto_accept" class="form-control" required ng-options="o.value as o.name for o in aliasOptions">
													</select>
													<label>Auto Accept</label>
												</div>
<!-- 
												<div class="form-group">
													<label></label>
													<div class="radio-custom radio-info mb15">
														<input type="radio" name="types" id="yes{{$index}}" ng-model="item.auto_accept" ng-value="1">
														<label for="yes{{$index}}" class="pt5">Yes</label>
														<input type="radio" name="types" id="no{{$index}}" ng-model="item.auto_accept" ng-value="0">
														<label for="no{{$index}}" class="pt5">No</label>
													</div>
												</div> -->
											</div>
											<div class="col pl-1">
												<a href="#" class="hod-button red" ng-click="removeAlias($index)">Remove</a>
											</div>
										</div>

										<a href="#" class="hod-button blue" ng-click="saveAlias()">Save</a>
			
                                    </div>
								</div>
							</div>
						</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
